import React from 'react';

function NotFoundPage() {
  return (
    <div className="notfoundpage" style={{
      height: "100vh", width: "100vw",
      textAlign: "center", color: "#bfa600", fontFamily: "Zelda, sans-serif",
      fontSize: "3em"
    }}>
      404 NOT FOUND
    </div>
  )
}

export default NotFoundPage